import { useCallback, useEffect, useState } from 'react';

/** Intervalo entre verificações de nova versão (2 minutos). */
const VERSION_POLL_INTERVAL_MS = 2 * 60 * 1000;

/** URL do manifesto de build gerado em dist/version.json. */
const VERSION_MANIFEST_URL = `${import.meta.env.BASE_URL}version.json`;

interface VersionManifest {
  buildTime: string;
}

/**
 * Compara o buildTime do bundle atual com o do servidor.
 * Em produção, polling periódico detecta deploys sem recarregar a página.
 */
export function useAppVersion(): { hasUpdate: boolean } {
  const [hasUpdate, setHasUpdate] = useState(false);

  const checkForUpdate = useCallback(async (): Promise<void> => {
    try {
      const response = await fetch(`${VERSION_MANIFEST_URL}?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!response.ok) return;

      const data = (await response.json()) as VersionManifest;
      if (!data.buildTime || data.buildTime === __BUILD_TIME__) return;

      setHasUpdate(true);
    } catch {
      // Falha de rede ou arquivo ausente: não interrompe o uso do app.
    }
  }, []);

  useEffect(() => {
    if (!import.meta.env.PROD) return;

    void checkForUpdate();

    const intervalId = window.setInterval(() => {
      void checkForUpdate();
    }, VERSION_POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [checkForUpdate]);

  return { hasUpdate };
}
